import log from '@/logger'
import intervalMixin from '@/mixins/interval'

export default {
  mixins: [intervalMixin],
  props: {
    autoclose: {
      type: [Number, String]
    },
    hideCloseButton: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String
    }
  },
  data () {
    return {
      timeLeft: 0
    }
  },
  created () {
    log.info('modal.lifecycle.created')
    if (this.autoclose) {
      log.info('modal.with-autoclose', this.autoclose)
      this.timeLeft = parseInt(this.autoclose, 10)
      this.setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--
        } else {
          this.$emit('close')
        }
      }, 1000)
    }

    // Block page scroll
    const scrollY = window.scrollY
    document.body.style.position = 'fixed'
    document.body.style.width = '100%'
    document.body.style.top = `-${scrollY}px`
  },
  destroyed () {
    log.info('modal.lifecycle.destroyed')

    // Free page scroll
    const scrollY = document.body.style.top
    document.body.removeAttribute('style')
    window.scrollTo(0, parseInt(scrollY, 10) * -1)
  },
  methods: {
    closeModal () {
      this.$emit('close')
    }
  }
}
